import styled from "styled-components";

import "../../../GlobalStyles/Font.css";

export const ContainerModel = styled.div`
  max-width: 100%;
  background: #fff;
  border-radius: 20px;
  margin: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 744px) {
    max-width: 348px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
  }
`;

export const ContentContainerModel = styled.div`
  padding: 16px;
  text-align: center;

  @media (min-width: 1440px) {
    padding: 24px;
  }
`;

export const TitleModel = styled.h1`
  font-size: 24px;
  font-family: Exo2 Light;

  margin-top: 24px;

  @media (min-width: 1440px) {
    font-size: 36px;
  }
`;

export const StepsAuthCode = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;
  margin-top: 10px;

  @media (min-width: 1024px) {
    margin-top: 20px;
  }
`;

export const EnteredCode = styled.input`
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  width: 278px;
  font-size: 20px;
  padding: 13px 20px;
  font-family: Exo2 Light;
  margin-top: 20px;

  @media (min-width: 428px) {
    width: 318px;
  }

  @media (min-width: 744px) {
    width: 268px;
  }

  @media (min-width: 1024px) {
    width: 229px;
  }

  @media (min-width: 1440px) {
    width: 360px;
  }
`;

interface ButtonSignProps {
  $filled: boolean;
}

export const ButtonSign = styled.input<ButtonSignProps>`
  background: ${(props) => (props.$filled ? "#1A50C6" : "#6B8EDA")};
  border-radius: 20px;
  width: 100%;
  padding: 12px;
  font-size: 20px;
  font-family: Exo2 Light;
  color: #fff;
  margin-top: 30px;

  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }

  @media (min-width: 428px) {
    width: 358px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    width: 269px;
  }

  @media (min-width: 1440px) {
    width: 400px;
  }
`;